import React from 'react';
import Pagination from 'Components/Pagination';
import RowsSelector from 'Components/RowsSelector';

export default ({handleClick, activePage, outCount, handleSelect, rowsCount}) => (
  <footer className='list-scene__footer'>
    <RowsSelector allRowsCount={outCount} handleRowsSelect={handleSelect} selectedRowsCount={rowsCount} />
    <Pagination
      handleClick={handleClick}
      activePage={activePage}
      allRowsCount={outCount}
      selectedRowsCount={rowsCount}
    />
  </footer>
);



// WEBPACK FOOTER //
// ./src/app/Scenes/DashboardScene/Footer.jsx